module.exports = __webpack_public_path__ + "static/FAQ-share1-c3522931609b2696df2efd68dd63c30a.jpg";